import { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';

export default function Encaixe({ show, onHide, onConfirm, horarioSugestao = '' }) {
  const [horario, setHorario] = useState('');

  // Atualiza o estado com a sugestão sempre que o modal abre
  useEffect(() => {
    if (show) {
      setHorario(String(horarioSugestao || '').replace(/\D/g, ''));
    }
  }, [show, horarioSugestao]);

  // Permite apenas números
  const handleChangeHorario = (e) => {
    const apenasNumeros = e.target.value.replace(/\D/g, '');
    setHorario(apenasNumeros);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!horario) return;

    onConfirm(Number(horario));
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} size="sm" centered backdrop="static">
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton className="py-2 bg-light">
          <Modal.Title style={{ fontSize: '0.95rem', fontWeight: 600 }}>
            Inserir Horário de Encaixe
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="py-3">
          <Form.Group controlId="inputHorarioEncaixe">
            <Form.Label className="small text-muted mb-1">
              Horário do Encaixe (ex: 830 para 08:30)
            </Form.Label>
            <Form.Control
              type="text"
              inputMode="numeric"
              size="sm"
              value={horario}
              onChange={handleChangeHorario}
              placeholder="Ex: 830, 1415"
              autoFocus
              maxLength={4}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer className="py-2 bg-light">
          <Button variant="outline-secondary" size="sm" onClick={onHide}>
            Cancelar
          </Button>
          <Button variant="success" size="sm" type="submit" disabled={!horario}>
            Confirmar Encaixe
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
